/**
 * Lowercase, non-delimited SHA-256 hex digest.
 * Used to derive the Gainsight PX user id from an email address, per the
 * Ideagen Gainsight PX specification.
 *
 * Returns null when the Web Crypto API is unavailable (e.g. a non-secure
 * context), so callers can skip identification rather than throw.
 */

export const sha256Hex = async (value: string): Promise<string | null> => {
  const subtle = typeof window !== 'undefined' ? window.crypto?.subtle : undefined;
  if (!subtle) {
    console.warn('Web Crypto API unavailable; cannot derive hashed identifier');
    return null;
  }
  try {
    const digest = await subtle.digest('SHA-256', new TextEncoder().encode(value));
    return Array.from(new Uint8Array(digest))
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
  } catch {
    console.warn('SHA-256 digest failed; cannot derive hashed identifier');
    return null;
  }
};
